import { useI18nContext } from "@hopper-b2b/i18n";

interface FormatGuestsParams {
  adultCount: number;
  childCount?: number;
  childrenAges?: number[];
}

export const useFormatGuests = () => {
  const { t } = useI18nContext();

  const formatGuests = ({
    adultCount,
    childCount = 0,
    childrenAges = [],
  }: FormatGuestsParams): string => {
    const adultsText = t("hotels.hotelSummary.adults", { count: adultCount });

    if (childCount === 0) {
      return adultsText;
    }

    const childrenText = t("hotels.hotelSummary.children", {
      count: childCount,
    });

    const childrenAgesText =
      childrenAges.length > 0
        ? `(${childrenAges
            .map((age) => t("hotels.hotelCard.childAge", { age }))
            .join(", ")})`
        : "";

    return `${adultsText} ${childrenText} ${childrenAgesText}`.trim();
  };

  return { formatGuests };
};
